import {useAuthUserStore} from "@/stores/auth";

export default {
    index(academyUuid) {

        return useAuthUserStore().getApiClient.get('/reports/balance/transactions', {
            params: {
                academy_uuid: academyUuid
            }
        })
    }
}